// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-nocheck

/**
* This service is based on
* Lenas null'sches System
* x = true/false/null
* answered(null) = false
* or(x, null) = x
* and(x, null) = false
* not(null) = true
* evaluiert condition als null passiert nichts
*
*/

/**
* Inserts answers into leafs of the tree identified by 'questionLabel' and 'loopIndex'.
* @param tree to evaluate. For example: {"questionLabel": 2, "value": "2019-10-18", "leafType": "date", "nodeType": "leaf", "operation": "less", "secondValue": ""}
* @param answer to insert. For example: {"answer": "2022-02-02", "questionLabel": 2, "loopIndex": 0}
*/
export function insertAnswer(tree, answer) {

  // multiple choice elements can return empty arrays when choosing and afterwards unchoosing the same answer
  // we dont want to save empty arrays and instead delete the entry
  if (Array.isArray(answer.answer) && answer.answer.length === 0){
    deleteAnswer(tree, answer.questionLabel, answer.loopIndex);
    return;
  }

  getLeafs(tree, answer.questionLabel)
  .forEach(leaf => {
    // no saving of empty arrays in the condition tree
    leaf.answers ? leaf.answers[answer.loopIndex] = answer.answer : leaf.answers = {[answer.loopIndex]: answer.answer}
  })
} 

/**
*  Evaluates the specified condition tree based on 'answers' of lesson
*
* @param tree ((nested) condition JSON) to evaluate. For example {"questionLabel": 2, "value": "2019-10-18", "leafType": "date", "nodeType": "leaf", "operation": "less", "secondValue": ""}
*
* @param answers (nested JSON Object) all answers of the lesson, each element has entry with key position and its repetition answers
* example: {"2": {"0": "2022-02-02", "2": "2022-02-02"}, "5": {"0": true}}
* meaning: questionLabel 2 has 3 repetitions, with answers for first and third; questionlabel 5 has no repetition & 1 answer
*
* @returns {boolean} result of the evaluation. Null means, that there are missing answers.
*/
export function evaluateCondition(tree, answers) {
  let bool;
  let boolList = [];
  if (tree.nodeType === "leaf") {
    if(answers != undefined && answers[tree.questionLabel] != undefined){
      for (let key in answers[tree.questionLabel]){
        let answer = answers[tree.questionLabel][key];
        if(tree.leafType === "slider"){
          answer = Number(answer);
          tree.value = Number(tree.value);
          tree.secondValue = Number(tree.secondValue);
        }else if(tree.leafType === 'date'){
          //if date is saved as 2022-04-20T12:34:56.000Z change to 2022-04-20
          if(answer === null){
            boolList.push(false);
            break;
          }else if(answer.includes("T")){
            answer = answer.substring(0,10);
          }
        }else if(tree.leafType === 'table'){
          //answers saved as array should be evaluated as sum, but only if all questions are filled out
          //check if null values included -> evaluated to false
          if(answer.includes(null)){
            boolList.push(false);
            break;
          }
          // answer.filter(answ => answ != null); //filter null values first
          answer = answer.reduce((a, b) => a + b, 0);
        }
        if (tree.operation === "answered") {
          boolList.push((answer != null && answer != "") || answer === false)
        } else {
          if (tree.leafType === 'question' && Array.isArray(answer)) {
            // for Multiple Choice Questions
            boolList.push(answer.includes(tree.value));
          } else if (tree.leafType === 'question') {
            boolList.push(answer === tree.value)
          } else if (answer === null || answer === "" || answer === false) {
            boolList.push(false);
          } else {
            switch (tree.operation) {
              case "less":
              boolList.push(answer < tree.value)
              break;
              case "lessEqual":
              boolList.push(answer <= tree.value)
              break;
              case "greater":
              boolList.push(answer > tree.value)
              break;
              case "greaterEqual":
              boolList.push(answer >= tree.value)
              break;
              case "equals":
              boolList.push(answer === tree.value)
              break;
              case "notEquals":
              boolList.push(answer != tree.value)
              break;
              case "between":
              boolList.push(tree.value <= answer && answer <= tree.secondValue)
              break;
              default:
            }
          }
        }
      }
    }
    bool = boolList.includes(true)
  } else {
    let boolList = [];
    for (var child in tree.children) {
      boolList.push(this.evaluateCondition(tree.children[child], answers));
    }
    if (tree.nodeType === "and") {
      bool = !boolList.includes(false);
    } else if (tree.nodeType === "or") {
      bool = boolList.includes(true);
    } else if (tree.nodeType === "not") {
      bool = !boolList[0];
    }
  }
  return bool
}


export function getAllLeafs(tree) {
  let result = [];
  if (tree.nodeType === "leaf") {
    result.push(tree);
  } else {
    tree.children.forEach(child => result.push(getAllLeafs(child)))
  }
  return result.flat(100);
}

export function getLeafs(tree, questionLabel) {
  let result = [];
  getAllLeafs(tree).filter(leaf => leaf.questionLabel === questionLabel).forEach(leaf => result.push(leaf))
  return result;
}

export function deleteAnswer(tree, questionLabel, loopIndex){
  getLeafs(tree, questionLabel).forEach(leaf => {
    delete leaf.answers[loopIndex];
  })
}

export function timeZone(language){
  if(language === "de"){
    return "de-DE"
  }else{
    return "en-US"
  }
}

export function dateOptions(){
  return { weekday: 'long', year: 'numeric', month: 'long', day: 'numeric', timeZone: 'UTC' }
}

export function timeOptions(){
  return { hour: 'numeric', minute: 'numeric', timeZone: 'UTC' }
}

export function getTranslations(){
  return {
    "de": {
      yes: "Ja",
      no: "Nein",
      time: "Uhr"
    },
    "en": {
      yes: "Yes",
      no: "No",
      time: ""
    }
  }
}

/**
*  Evaluates the specified reference string based on 'answers' of lesson
* @param textWithReferences (String) to evaluate. For example "Die Antwort war: {{2}}"
*
*
* @param previewAnswers (nested JSON Object) all answers of the lesson, each element has entry with key position and its repetition answers
*
* example: {"2": {"0": "2022-02-02", "2": "2022-02-02"}, "5": {"0": true}}
* meaning: questionLabel 2 has 3 repetitions, with answers for first and third; questionlabel 5 has no repetition & 1 answer
*
*
* @param questionElements (JSON Object), all question elements as json with element properties at key position;
* needs keys
* - questionType (String) (for TextDate questions the specific type from values array has to be used here)
*`- values (Array) (for Single/Multiple Choice, can be empty otherwise)
* - translations (JSON Object with language as key, Array with answer strings as value) (answer translations, for Single/Multiple Choice, can be empty otherwise)
*
* example: {"2": {"questionType": "TextDate", "values": [], translations: {}}, "5": {"questionType": "SingleChoice", "values": [a, b],
* translations: {"en": ["answer a", "answer b"], "de": ["Antwort a", "Antwort b"]}}}
*
*
* @param language (String) in which the lesson in shown to the user
*
*
* @returns string with evaluated references
*/
export function evaluateReferences(textWithReferences, previewAnswers, questionElements, language){
  var self = this;
  var text = "";
  if(textWithReferences){
    //replace tags
    text = String(textWithReferences).replace(/&lt;/g, '<').replace(/&gt;/g, '>');
  }

  //first replace gets {{number}} as x -> brackets are replaced in second replace -> only number -> get answer
  var evaluatedText = text.replace(/\{{2}([^}{]+)}{2}/g, function(x){
    var number = x.replace(/{/g, "").replace(/}/g, "");
    if(previewAnswers[number] && previewAnswers[number][0] != undefined){
      var selectedQuestion = questionElements[number].questionType;
      var value = previewAnswers[number][0];
      var values = questionElements[number].values;
      var answers = questionElements[number].translations ? questionElements[number].translations[language] : {};
      var index;
      var answerString = "";
      var evaluatedValue = "";

      switch (selectedQuestion){
        case "YesNoSwitch":
        if(value){
          evaluatedValue = self.getTranslations()[language]["yes"];
        }else{
          evaluatedValue = self.getTranslations()[language]["no"];
        }
        break;

        case "SingleChoice":
        index = values.findIndex(elem => elem === value);
        if(index != -1){
          evaluatedValue = answers[index];
        }
        break;

        case "MultipleChoice":
        for(var a in value){
          index = values.findIndex(elem => elem === value[a]);
          if(index != -1){
            if(answerString != ""){
              answerString += ", ";
            }
            answerString += answers[index];
          }else{
            answerString += "";
          }
        }
        evaluatedValue = answerString;
        break;

        case "Slider":
        case "TextString":
        case "TextArea":
        evaluatedValue = value;
        break;

        case "TextDate":
        case "TextTime":
        case "TextDateTime":
        var dateVal = new Date(value);
        //date is in UTC -> convert to timezone of user
        dateVal.setFullYear(dateVal.getUTCFullYear());
        dateVal.setMonth(dateVal.getUTCMonth());
        dateVal.setDate(dateVal.getUTCDate());
        dateVal.setHours(dateVal.getUTCHours());
        dateVal.setMinutes(dateVal.getUTCMinutes());

        if(selectedQuestion === "TextDate" || selectedQuestion === "TextDateTime"){
          answerString = dateVal.toLocaleDateString(self.timeZone(language), self.dateOptions);
        }
        if(selectedQuestion === "TextTime" || selectedQuestion === "TextDateTime"){
          if(answerString != ""){
            answerString += ", ";
          }
          let time = dateVal.toLocaleTimeString(self.timeZone(language), self.timeOptions);
          if(language === "de"){
            time = time.substring(0,5) + " " + self.getTranslations()[language]["time"];
          }else if(language === "en"){
            let split = time.split(":");
            time = split[0] + ":" + split[1];
            time += (split[2].includes("AM")) ? " am" : " pm";
          }
          answerString += time;
        }
        evaluatedValue = answerString;
        break;

        case "QuestionTable":
        //sum of value
        value.filter(answ => answ != null);
        evaluatedValue = value.reduce((a, b) => a + b, 0);
        break;

        default:
        break;
      }

      return evaluatedValue
    }else{
      return ""
    }
  });

  //nested references are not evaluated -> check if evaluatedText includes {{ }} and evaluate again
  if(evaluatedText.includes("{{")){
    evaluatedText = this.evaluateReferences(evaluatedText, previewAnswers, questionElements, language);
  }

  return evaluatedText
}
